import {
  collection,
  doc,
  getDocs,
  addDoc,
  getFirestore,
  query,
  setDoc,
  where
} from 'firebase/firestore'
import { getAuth } from 'firebase/auth'

const actions = {
  async fetchToken() {
    try {
      const auth = getAuth()
      const currentUser = auth.currentUser
      if (!currentUser) {
        return { ok: false, error: 'auth/not-logged-in' }
      }

      const userIdToken = await currentUser.getIdToken(true)

      const url = 'https://europe-west1-ows-webedi-prod.cloudfunctions.net/app/api/service-token'

      const res = await fetch(url, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userIdToken}`,
        },
      })

      if (!res.ok) {
        return { ok: false, error: `service-token/http-${res.status}` }
      }

      const json = await res.json()
      const idToken = json?.idToken
      if (!idToken) {
        return { ok: false, error: 'service-token/no-idToken' }
      }

      return idToken
    } catch (e) {
      return { ok: false, error: 'service-token/exception' }
    }
  },

  async createUser({}, payload) {
    const auth = getAuth()
    const user = auth.currentUser
    if (!user) throw new Error('Not authenticated')

    const idToken = await user.getIdToken(true)
    const db = getFirestore()

    const q = query(collection(db, 'users'), where('username', '==', payload.user.username))
    const querySnapshot = await getDocs(q)
    if (querySnapshot.docs.length) {
      return 'Käyttäjätunnus on jo varattu'
    }

    const url = 'https://europe-west1-ows-webedi-prod.cloudfunctions.net/app/api/createuser'
    const body = JSON.stringify({
      email: payload.user.username,
      password: payload.user.password,
      firstname: payload.user.firstname,
      lastname: payload.user.lastname
    })

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${idToken}`,
        'Content-Type': 'application/json'
      },
      body
    })

    const response = await res.json()
    if (!res.ok) throw new Error(response?.message || 'Create user failed')

    const uid = response.uid
    if (!uid) throw new Error('Missing uid in response')

    const orgQ = query(collection(db, 'organisations'), where('name', '==', payload.user.organisation))
    const orgSnap = await getDocs(orgQ)
    if (!orgSnap.docs.length) throw new Error('Organisation not found')

    const orgid = orgSnap.docs[0].id
    const orgRef = doc(db, 'organisations', orgid)

    await setDoc(doc(db, 'users', uid), {
      admin: false,
      disabled: false,
      username: payload.user.username,
      email: payload.user.username,
      firstname: payload.user.firstname,
      lastname: payload.user.lastname,
      phone: payload.user.phone,
      organisation: orgRef
    })
  },

  async createOgranisation({}, payload) {
    const db = getFirestore()
    const q = query(collection(db, 'organisations'), where('partyid', '==', payload.partyid))
    const querySnapshot = await getDocs(q)
    if (querySnapshot.docs.length) {
      return 'Organisaatio tällä osapuolitunnuksella on jo luotu'
    }

    await addDoc(collection(db, 'organisations'), {
      info: payload.info,
      name: payload.name,
      orgtype: payload.orgtype,
      partyid: payload.partyid
    })
  },

  async createNotification({}, payload) {
    const auth = getAuth()
    if (!auth.currentUser) throw new Error('Not authenticated')

    const db = getFirestore()

    await addDoc(collection(db, 'notifications'), {
      date: payload.date,
      title: payload.title,
      text: payload.text
    })
  }
}

export default {
  namespaced: true,
  actions
}
